export function formatDisplayNumber(
  value: number,
  options: Intl.NumberFormatOptions = {},
): string {
  return new Intl.NumberFormat("en-US", { signDisplay: "negative", ...options }).format(value);
}

export function formatDisplayDateTime(value: Date | string): string {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "short",
    timeStyle: "short",
  }).format(value instanceof Date ? value : new Date(value));
}
